
const qiniu: any = require("qiniu-js");
import { Request } from "@/api/request";
import { getQiNiuYunToken } from "@/api/http";
import { ElMessage } from "element-plus";
import { defineComponent, ref, inject, onMounted } from "vue";

export default defineComponent({
    name: "banner",
    setup() {
        const setTitle: any = inject("setTitle");
        setTitle(["运营管理", "广告图设置"]);
        let bannerUrl = ref("");
        let middleUrl = ref("");
        // 上传图片功能
        let token = "",
            bucketURL = "",
            uploadImg = (file: any) => {
                return new Promise((resolve: any, rejetc) => {
                    let config = {
                        useCdnDomain: true,
                        // region: qiniu.region.z2,
                    };
                    let putExtra = {
                        fname: "",
                        params: {},
                        mimeType: null,
                    };
                    let observable: any = {};

                    observable = qiniu.upload(
                        file,
                        null,
                        token,
                        putExtra,
                        config
                    );
                    const observer = {
                        next(res: any) {},
                        error(err: any) {},
                        complete(res: any) {
                            resolve(res);
                        },
                    };
                    observable.subscribe(observer);
                });
            },
            beforeAvatarUpload = (file: File) => {
                const isJPG = file.type === "image/jpeg";
                const isPNG = file.type === "image/png";
                if (!isJPG && !isPNG) {
                    ElMessage.error("上传图片只能是 JPG 或 PNG 格式!");
                }
                return isJPG && isPNG;
            },
            handleChange = (file: any,type:any) => {
                uploadImg(file.raw).then((res: any) => {
                    if (type==2){
                        bannerUrl.value = bucketURL + res.key;
                    }else {
                        middleUrl.value = bucketURL + res.key;
                    }
                    Request.axiosInstance({
                        url: "adminapi/Banner/create",
                        data: {
                            images: res.key,
                            type:type
                        },
                    });
                });
            };
        onMounted(() => {
            getQiNiuYunToken().then((res: any) => {
                token = res.content.token;
                bucketURL = res.content.domain;
            });
            Request.axiosInstance({
                url: "adminapi/Banner/bannerInfo",
            }).then((res: any) => {
                bannerUrl.value = res?.content?.list.url || "";
                middleUrl.value = res?.content?.list.middle_url || "";
            });
        });

        return {
            bannerUrl,
            middleUrl,
            beforeAvatarUpload,
            handleChange,
        };
    },
});
